import { MovingWaves, WaveContainer, Waves } from './styles'
import React from 'react'

export function WaveEffect() {
    return (
        <WaveContainer>
            <Waves
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                shapeRendering="auto"
                viewBox="0 24 150 40"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            >
                <defs>
                    <path
                        id="gentle-wave"
                        d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
                    />
                </defs>
                <MovingWaves>
                    {[...Array(6)].map((_, index) => (
                        <use
                            key={index}
                            xlinkHref="#gentle-wave"
                            x="100"
                            y={(index + 1) * 2}
                            fill={`rgba(14, 25, 32, ${
                                index === 5 ? 0.95 : 0.4 - index * 0.1
                            })`}
                        />
                    ))}
                </MovingWaves>
            </Waves>
        </WaveContainer>
    )
}
